module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4U0VCd/tc-custom/9781480404564.jpg?1733104713457",
      "alt": "This image is the cover for the book Gold Dust"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Gold Dust\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Baseball-loving seventh grader Richard has hopes of turning himself and the new kid, Napoleon, into the best baseball players Boston has seen since the Gold Dust Twins")]), _vm._v("“As long as you have baseball on your side you can overcome anything.” Seventh grader Richard Moncreif is convinced baseball will ease newcomer Napoleon Charlie Ellis’s transition to life in Boston. Napoleon is unlike anyone he’s ever met: poised, well educated, and a cricket player from the Caribbean. Napoleon is one of the few black students at Richard’s school, where racism is pervasive. But Richard believes that he and Napoleon can get through any hardship and become the next Gold Dust Twins, just like the famous pair of Red Sox rookies from 1975. After all, Napoleon is a natural athlete, and Richard knows everything anyone could possibly know about baseball. He just needs Napoleon to play along. This ebook features an illustrated biography of Chris Lynch including rare images from the author’s personal collection. \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Chris Lynch\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Chris Lynch (b. 1962), a Boston native, is an award-winning author of several acclaimed young adult novels, including "), _c('i', [_vm._v("Freewill ")]), _vm._v("(2001), which won the Michael L. Printz Honor, and National Book Award finalist "), _c('i', [_vm._v("Inexcusable")]), _vm._v(" (2005). Lynch holds an MA from the writing program at Emerson College, and teaches in the creative writing MFA program at Lesley University. He mentors aspiring writers and continues to work on new literary projects while splitting time between Boston and Scotland.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0